import React from 'react';
import { createPortal } from 'react-dom';

const ErrorModal = ({ message, onClose }) => {
    return createPortal(
        <div
            className="fixed inset-0 bg-[rgba(88,88,88,0.7)] flex justify-center items-center z-[99999]"
            onClick={onClose}
        >
            <div
                className="bg-white p-[30px] rounded-xl w-[95%] max-w-sm text-center relative shadow-[0_0_10px_rgba(0,0,0,0.3)]"
                onClick={(e) => e.stopPropagation()}
            >
                <h3 className="mt-0 text-[#d9534f]">Error</h3>
                <p className="my-5 text-black">{message}</p>
                <button
                    className="px-5 py-2 bg-[#d9534f] border-none text-white rounded cursor-pointer font-[inherit] hover:opacity-80"
                    onClick={onClose}
                >
                    OK
                </button>
            </div>
        </div>,
        document.body
    );
};

export default ErrorModal;
